import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RTL_LANGUAGES } from "@/redux/reducers/language";

/**
 * Keeps <html lang>/<html dir> in sync with the dashboard user's UI language
 * so Tailwind's built-in rtl:/ltr: variants work app-wide from a single
 * source. Call once near the app root.
 */
export function useLanguageSync() {
    const current = useSelector((s) => s.language?.current) ?? "en";

    useEffect(() => {
        document.documentElement.lang = current;
        document.documentElement.dir = RTL_LANGUAGES.includes(current) ? "rtl" : "ltr";
    }, [current]);
}
